import { ReactElement } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'app/utils';
import { useAuth } from 'app/context';
//Icons
import PersonIcon from '@mui/icons-material/Person';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import SummarizeIcon from '@mui/icons-material/Summarize';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

interface Props {
  open: boolean;
}

export const Menu = ({ open }: Props): ReactElement => {
  const navigate = useNavigate();

  const { loggedUser } = useAuth();

  const { t } = useTranslation();
  return (
    <>
      <List>
        {/* {loggedUser?.role === 'admin' && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => {
                navigate(ROUTES.users);
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <PersonIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={t('user.title')} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )} */}
        {/**** MEDICAL CENTER ****/}
        {loggedUser?.role === 'admin' && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => {
                navigate(ROUTES.medicalCenters);
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <LocalHospitalIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={t('medicalCenter.title')} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )}
        {/**** DOCTOR ****/}
        {loggedUser?.role === 'medical_center' && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => {
                navigate(ROUTES.doctors);
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <MedicalServicesIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={t('doctor.title')} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )}
        {/**** PATIENT ****/}
        {loggedUser?.role === 'medical_center' && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => {
                navigate(ROUTES.patients);
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <PersonIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={t('patient.title')} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )}
        {/**** REPORT ****/}
        {loggedUser?.role === 'medical_center' && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => {
                navigate(ROUTES.reports);
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <SummarizeIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={t('report.title')} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )}
        {/**** PDF CONFIGURATION ****/}
        {loggedUser?.role === 'medical_center' && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => {
                navigate(ROUTES.pdfConfiguration);
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <InsertDriveFileIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={t('pdfConfig.title')} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
      <Divider />
    </>
  );
};
